






























































































































































import { Component, Vue } from "vue-property-decorator";
import { ActionSheet, Button, Step, Steps, Dialog, Icon } from "vant";
import { getBrowser } from "@/utils/browser";
import { jumpLink, setStatementDetailInfo } from "@/utils/hybirdMethods";
const browser = getBrowser();
@Component({
  components: {
    ActionSheet,
    [Steps.name]: Steps,
    [Step.name]: Step,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [Icon.name]: Icon,
  }
})

export default class AccountActivation extends Vue {
  jumpUrl:any = 'https://www.sfc.hk/edistributionWeb/gateway/TC/circular/intermediaries/supervision/doc?refNo=19EC46'

  future:any = require('@/assets/images/open-account/future.png')
  security:any = require('@/assets/images/open-account/security.png')
  isApp = browser.isApp;
  statusData: any = ""; // 状态
  openAccountInfo: any = "";
  isShowActions:boolean = false;
  actionsList:any = []

  show: any = false;

  get accountList(){
    return [
      {text: this.$t('funds.accountName[0]'), account_type: 1 },
      {text: this.$t('funds.accountName[1]'), account_type: 2 }
    ]
  }

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  get account_type() {
    return this.$route.query.account_type;
  }

  get currentLang() {
    return (this as any).$i18n.locale || 'zh';
  }

  created() {
    this.getUrl();
    this.accountSituationV2();
  }

  getUrl(){
    (this as any).$apis.getEnum({key:'sfcDesribe'}).then(res =>{
        if(res){
         this.jumpUrl =  res[0].value
        }
    })
  }
  goActivation() {
    if((this as any).account_type == 3){
      (this as any).show = true;
    }else{
      (this as any).toBankCardList((this as any).account_type);
    }
  }
  goHome(){
    jumpLink('go_home');
  }
  toBankCardList(account_type) {
    (this as any).$apis
      .getBankList()
      .then(res => {
        if(res && res.length > 0){
          this.$router.push({
            path: "/bank-card-list",
            query: { ...this.$route.query, showType: '3', account_type}
          });
        }else{
          this.$router.push({
            path: "/bank-card-add",
            query: { ...this.$route.query, showType: '3', account_type}
          });
        }
      })

  }
  accountSituationV2(){
    (this as any).$apis.accountSituationV2().then(res =>{


      // 1 期货  2 证券
      this.openAccountInfo = res.get_open_account_info;
      this.statusData = res.account_status
      if((this as any).account_type == 1){
        this.statusData = res.is_verify_hk || 0;
      }else{
        this.statusData = res.is_verify_hb || 0;
      }
      if(this.statusData != 0 && this.isApp){
        setStatementDetailInfo({
          headerTitle: this.$t('mki18n.t00033')
        });
      }
    })
  }

  showService(){
    if((this as any).isShowActions) return;
    (this as any).$apis.getEnum({
      key: 'customerServiceUrl,customerServicePhone,customerServiceEmail'
    }).then(data => {
      const service = data.find(item => item.key == 'customerServiceUrl');
      const phone = data.find(item => item.key == 'customerServicePhone');
      const email = data.find(item => item.key == 'customerServiceEmail');
      (this as any).actionsList = [
        {type: 'service', text: this.$t('m000024'), ...service },
        {type: 'tel', text: this.$t('openAccount.t000029'), ...phone },
        {type: 'mailto', text: this.$t('openAccount.t000030'), ...email }
      ];
      (this as any).isShowActions = true;
    })
  }
  actionHand(item){
    (this as any).$JsBridge.callHandler('jumpPage', {
      type: 2,
      url: {
        tel: 'callPhone',
        mailto: 'sendEmail'
      }[item.type],
      data: item.value
    })
  }
  openService(e){
    window.open(e.value, '_blank');
  }
}
